export default {
  detail: {},
  projectTeam: [],
  projectData: {},
  crmProjectData: {},
  projectListSelect: [],
  projectCustomer: {},
  projectCustomerSelect: [],
  projectContractSelect: [],
  projectSalesmanSelect: [],
  projectPackage: [],
};
